const getStaleTime = () => {
    // 10 minutes
    return 600000;
};
export default getStaleTime;
